//components

import Login from "../components/Login/Login.vue";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword.vue";
import ApplicationForm from "@/components/ApplicationForm/ApplicationForm.vue";
import dashboardRoutes from "./dashboard";


export const routes = [
  {
    path: "/",
    component: Login,
    meta: {
      required: false,
    },
  },
  {
    path: "/applicationForm",
    component: ApplicationForm,
    meta: {
      required: false,
    },
  },
  {
    path: "/forgotPassword",
    component: ForgotPassword,
    meta: {
      required: false,
    },
  },
  ...dashboardRoutes
];
